import { AuthApi } from "../shared/api/AuthApi";
import { ProjectApi } from "../shared/api/ProjectApi";
import { MileStoneApi } from "../shared/api/MileStoneApi";
import { UserApi } from "../shared/api/UserApi";
import { TaskApi } from "../shared/api/Taskapi";
import { PermissionsApi } from "../shared/api/PermissionsApi";
import { ProfileApi } from "../shared/api/ProfileApi";
import { AssignUserApi } from "../shared/api/AssignUserApi";
import { BoardApi } from "../shared/api/BoardApi";
import { NotificationApi } from "../shared/api/NotificationApi";
import { BhuApi } from "../shared/api/BhuApi";
import { AnnouncementsApi } from "../shared/api/AnnouncementsApi";
import { DocumentApi } from "../shared/api/DocumentApi";
import { ChartApi } from "../shared/api/ChartApi";
import { CalendarApi } from "../shared/api/Calendar.Api";
import { DashboardApi } from "../shared/api/DashboardApi";
import { CapaApi } from "../shared/api/CapaApi";
import { GoalApi } from "../shared/api/GoalsApi";
import { CardApi } from "../shared/api/CardApi";
import { ReviewsApi } from "../shared/api/Reviews.Api";
import { DRIPApi } from "../shared/api/DR-IPApi";
import { CommentApi } from "../shared/api/CommentApi";
import { ToDoApi } from "../shared/api/ToDoApi";
import { ProductionFileLoadingApi } from "../shared/api/ProductionFileLoadingApi";
import { EmailSettingsApi } from "../shared/api/EmailSettingsApi";
import { ProcurementApi } from "../shared/api/ProcurementApi";
import { ChatApi } from "../shared/api/ChatApi";
import { AiAssistantApi } from "../shared/api/AiAssistantApi";
import { PushNotificationApi } from "../shared/api/PushNotificationApi";

export const rootMiddleware = [
  AuthApi.middleware,
  ProjectApi.middleware,
  MileStoneApi.middleware,
  UserApi.middleware,
  PermissionsApi.middleware,
  ProfileApi.middleware,
  AssignUserApi.middleware,
  BoardApi.middleware,
  NotificationApi.middleware,
  BhuApi.middleware,
  TaskApi.middleware,
  AnnouncementsApi.middleware,
  DocumentApi.middleware,
  ChartApi.middleware,
  CalendarApi.middleware,
  DashboardApi.middleware,
  CapaApi.middleware,
  GoalApi.middleware,
  CardApi.middleware,
  ReviewsApi.middleware,
  DRIPApi.middleware,
  CommentApi.middleware,
  ToDoApi.middleware,
  ProductionFileLoadingApi.middleware,
  EmailSettingsApi.middleware,
  ProcurementApi.middleware,
  ChatApi.middleware,
  AiAssistantApi.middleware,
  PushNotificationApi.middleware
];


